import { useNavigate } from '@tanstack/react-location'
import ScreenLayout from 'MediaManager/layouts/ScreenLayout'
import { getPackages } from 'MediaManager/services/packages'
import React, { useCallback } from 'react'
import DataTable from 'shared/components/DataTable'
import Loader from 'shared/components/Loader'
import { useRequest } from 'shared/hooks/useRequest'

const table = [
  {
    label: 'ID',
    data: (data) => data.id,
  },
  {
    label: 'Name',
    data: (data) => <span className="underline inline-block ">{data.name}</span>,
  },
  {
    label: 'Display Name',
    data: (data) => data.display_name,
  },
  {
    label: 'Vendor',
    data: (data) => data.vendor?.full_name,
  },
  {
    label: 'Price',
    data: (data) => (data.price ? `$${data.price.toLocaleString('en-US')}` : '-'),
  },
  {
    label: '# Rooms',
    data: (data) => `${data.room_classifications.length}`,
  },
  {
    label: 'Items',
    data: (data) => {
      const items = data.room_classifications
        .map((c) => c.categories)
        .join(',')
        .split(',')

      return items.length > 26 ? '26+' : items.length
    },
  },
  {
    label: 'Type',
    data: (data) => {
      if (!data.package_type) {
        return 'CSV'
      }
      if (data.package_type === 'concrete') {
        return 'Asset'
      }
      if (data.package_type === 'abstract') {
        return 'Category'
      }
    },
  },
  {
    label: '# Floor Plans',
    data: (data) => {
      return data.unit_plans?.length
    },
  },
]

function ManagePackages(props) {
  const getPackagesData = useCallback(async () => {
    const { data } = await getPackages()
    return data.packages
  }, [])

  const { data: packages, loading } = useRequest(getPackagesData)

  const navigate = useNavigate()

  const actions = [
    {
      label: 'Create package',
      action: () => {
        navigate({ to: `/packages/create` })
      },
    },
  ]

  return (
    <ScreenLayout title="Manage furniture packages">
      {loading && (
        <div className="flex items-center justify-center">
          <Loader />
        </div>
      )}
      {!loading && (
        <DataTable
          title="Furniture Packages"
          onRowClick={(i) => {
            navigate({ to: `/packages/edit?id=${i.id}` })
          }}
          structure={table}
          data={packages}
          actions={actions}
        />
      )}
    </ScreenLayout>
  )
}

export default ManagePackages
